<template>
    <div>
        <v-row class="ml-1 mr-1">
            <v-col>
                <v-select
                    :items="bodegasOrigen"
                    item-text="nombre"
                    item-value="id"
                    v-model="datita.bodega_origen"
                    label="Seleccione Bodega Origen"
                    @change="eventoCargarLotes();buscarDocumento()"
                    dense
                ></v-select>
            </v-col>
            <v-col>
                <v-select
                    :items="bodegasDestino"
                    item-text="nombre"
                    item-value="id"
                    v-model="datita.bodega_destino"
                    label="Seleccione Bodega Destino"
                    @change="eventoCargarMaxisacos();buscarDocumento()"
                    dense
                ></v-select>
            </v-col>
            <v-col>
                <date-picker
                    v-model="datita.fecha"
                    placeholder ="Seleccione Fecha"
                    label ="Seleccione Fecha"
                    format="DD-MM-YYYY"
                    :default-value="datita.fecha"
                    valueType="YYYY-MM-DD"
                    @change="eventoSetData();buscarDocumento()"
                ></date-picker>
            </v-col>
            <v-col>
                <v-select
                    :items="tipos"
                    item-text="texto"
                    item-value="valor"
                    v-model="datita.tipo"
                    label="Tipo Movimiento"
                    dense
                    @change="eventoCargarDocumentos()"
                ></v-select>
            </v-col>
            <v-col>
                <v-select
                    :items="motivos"
                    item-text="texto"
                    item-value="valor"
                    v-model="datita.motivo"
                    label="Motivo Movimiento"
                    dense
                    @change="eventoCargarDocumentos()"
                ></v-select>
            </v-col>

        </v-row>
            <v-alert v-if="mostrar_alert" dense border="left" type="warning"  >
                Guía  <strong>{{nro_guia}}</strong>, de fecha {{datita.fecha | formatearFecha}} ya se encuentra ingresada en movimiento nro:  <strong>{{datita.id}}</strong>
            </v-alert>
        <v-row class="ml-1 mr-1">
            <!-- DOCUMENTOS DINAMICOS -->
            <v-col cols="12" class="d-flex flex-wrap">
                <v-col cols="3"  v-for="(item, idx) in datita.datos_adicionales" :key="item.id" class="d-flex flex-column mb-2" >
                    <label class="mr-4">{{ item.documento }}</label>

                    <input class="input-group-text inputcito" type="text" v-if="item.tipo_dato == 'Texto'" @change="eventoSetData(item.documento)" v-model="item.valor_dato">
                    <input class="input-group-text inputcito" type="number" v-if="item.tipo_dato == 'Numero'" @change="eventoSetData" v-model="item.valor_dato">
                    <input class="input-group-text inputcito" type="file"  v-if="item.tipo_dato == 'Archivo'" @change="subir_archivo($event,idx)">
                    <input class="input-group-text inputcito" type="date" v-if="item.tipo_dato == 'Fecha'" @change="eventoSetData" v-model="item.valor_dato">
                </v-col>
            </v-col>
            <!-- DOCUMENTOS DINAMICOS -->
        </v-row>

    </div>
</template>


<script>

import { mapState,mapMutations } from 'vuex'

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';

export default {
    props: {
        bodegasOrigen: {
            type: Array,
            required: true
        },
        bodegasDestino: {
            type: Array,
            required: true
        },
        tipos: {
            type: Array,
            required: true
        },
        motivos: {
            type: Array,
            required: true
        },
        movimiento: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            datita:{
                id:'',
                fecha: '',
                tipo: '',
                motivo: '',
                bodega_origen: '',
                bodega_destino: '',
                documentos: [],
                datos_adicionales: [],
                maxisacos_lote: [],
                lotes: [],
                lote: '',
            },
            nro_guia: '',
            mostrar_alert:false,
        }
    },
    created() {
        this.datita.bodega_origen = this.movimiento.bodega_origen;
        this.datita.bodega_destino = this.movimiento.bodega_destino;
        if (this.movimiento.id) {
            this.datita.fecha = this.movimiento.fecha;
            this.datita.tipo = this.movimiento.tipo;
            this.datita.motivo = this.movimiento.motivo;
        }
        this.eventoCargarLotes();
    },
    methods: {
        eventoSetData(x = ''){
            console.log("ingreso a set:")
            this.$emit('set-data', this.datita)
            this.nro_guia = ''
            this.datita.datos_adicionales.forEach(d => {
                if((d.documento == "Nro Guía" || d.documento == "Nro Guia") 
                        &&  d.valor_dato){
                    this.nro_guia = d.valor_dato;

                }
            });
            if(x == "Nro Guía" || x == "Nro Guia"){
                this.buscarDocumento();
            }
        },
        async eventoCargarLotes(){
            this.mostrarLoading({titulo:'Cargando Lotes con Maxisacos disponibles...',color:'green'})
            this.datita.lotes = [];
            this.datita.lote = {id:''};

            let url = `${this.base_url}lotes/maxisacos/disponibles/${this.datita.bodega_origen}`;
            await this.axios.get(url, this.headers).then((res)=>{
                this.datita.lotes = res.data.data;
                this.datita.lote = this.datita.lotes.length > 0 ? this.datita.lotes[0] : {id:''};
                this.ocultarLoading();
                this.$emit('cargar-lotes', this.datita)

                this.eventoCargarDocumentos();
            }).catch((error)=>{
                console.log('error',error);
                this.ocultarLoading();
                this.$emit('cargar-lotes', this.datita)
            });
        },

        async eventoCargarMaxisacos(){
            let url = `${this.base_url}lotes/jumbos/disponibles_salida`;
            this.datita.maxisacos_lote = [];
            await this.axios.get(url,this.headers).then((res)=>{
                this.datita.maxisacos_lote = res.data.data;
                this.$emit('cargar-maxisacos', this.datita)
            }).catch((error)=>{
                console.log('error',error);
                this.$emit('cargar-maxisacos', this.datita)
            });
        },

        async eventoCargarDocumentos() {
            this.datita.documentos = [];
            this.datita.datos_adicionales = [];
            if (this.datita.tipo && this.datita.motivo) {
                await this.axios.get(`${this.base_url}mov_documentos?tipo_movimiento=${this.datita.tipo}&motivo_movimiento=${this.datita.motivo}&tipo_produccion_id=1&limit=999999`,this.headers).then((res)=>{
                    this.datita.documentos = res.data.data.data;
                    this.datita.documentos.forEach(d => {
                        this.datita.datos_adicionales.push({
                            mov_documentos_id:d.id,
                            valor_dato:'',
                            tipo_dato:d.tipo_dato_texto,
                            documento:d.documento
                        });
                    });

                    this.$emit('cargar-documentos', this.datita)

                }).catch((e)=>{
                    console.log(e);
                    this.$emit('cargar-documentos', this.datita)
                });
            } else {
                this.$emit('cargar-documentos', this.datita)
            }
            this.buscarDocumento();
        },

        validaVariables(){
            if(this.datita.bodega_origen !== '' && this.datita.bodega_destino !== ''
                && this.datita.fecha !== '' && this.datita.tipo !== '' 
                && this.datita.motivo  !== '' && this.nro_guia !== ''){
                return true;
            } else {
                return false;
            }
        },
        async buscarDocumento(){
            let alerta = false;
            if(this.validaVariables()){
                let query = `?=&bodega_origen=${this.datita.bodega_origen}&bodega_destino=${this.datita.bodega_destino}&guia=${this.nro_guia}`
                    query += `&fecha=${this.datita.fecha}&tipo_movimiento=${this.datita.tipo}&motivo_movimiento=${this.datita.motivo}&limit=1&page=1`
                await this.axios.get(`${this.base_url}movements${query}`,this.headers).then((res)=>{
                    if (res.data.data.data.length > 0){
                        alerta = true
                        this.datita.id = res.data.data.data[0].id;
                    } else {
                        this.datita.id = '';
                    }
                })
                this.mostrar_alert = alerta;
            }
        },

        async subir_archivo($event,idx){
            let archivo = $event.target.files[0];
            //this.mostrarLoading('Subiendo Archivo...');
            this.mostrarLoading({titulo:'Subiendo Archivo...',color:'green'})

            //subiendo el archivo
            let token = this.headers.headers['Authorization'];
            let cabecera = {
                headers:{
                    'Authorization':token,
                    'Content-Type':'multipart/form-data'
                }
            }
            let body = new FormData();
            body.append('archivo', archivo);
            let url = `${this.base_url}movimientos/subir_documento`;
            await this.axios.post(url, body, cabecera).then((res) =>{
                //this.enviarNombreArchivo(res);
                this.$set(this.datita.datos_adicionales[idx],'valor_dato',res.data.nombre_archivo);
                this.eventoSetData();
            }).catch((error) =>{
                console.log('error',error);
            });
            this.ocultarLoading();
            //console.log($event,idx);
        },
        ...mapMutations(['mostrarLoading', 'ocultarLoading']),

    },
    computed:{
        ...mapState(['base_url','headers']),
    },
    components:{
        DatePicker,
    },
}
</script>

